import { c as _c } from "react/compiler-runtime";
import { FirstDayOfWeek, getBrowserTimezone, getLocaleFirstDayOfWeek } from '../../utils/date';
import { storage_keys } from '../../utils/storage';
import useLocalStorage from './useLocalStorage';
export const useDatePreferences = () => {
  const $ = _c(9);
  const [timezone_preference] = useLocalStorage(storage_keys.timezone, null);
  const [first_day_of_week_preference] = useLocalStorage(storage_keys.first_day_of_week, null);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = getBrowserTimezone();
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const browser_timezone = t0;
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = getLocaleFirstDayOfWeek();
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const locale_first_day_of_week = t1;
  const t2 = timezone_preference ?? browser_timezone;
  const t3 = first_day_of_week_preference ?? locale_first_day_of_week;
  const t4 = timezone_preference == null;
  const t5 = first_day_of_week_preference == null;
  let t6;
  if ($[2] !== first_day_of_week_preference || $[3] !== t2 || $[4] !== t3 || $[5] !== t4 || $[6] !== t5 || $[7] !== timezone_preference) {
    t6 = {
      timezone: t2,
      timezone_preference,
      first_day_of_week: t3,
      first_day_of_week_preference,
      browser_timezone,
      locale_first_day_of_week,
      uses_browser_timezone: t4,
      uses_locale_first_day_of_week: t5
    };
    $[2] = first_day_of_week_preference;
    $[3] = t2;
    $[4] = t3;
    $[5] = t4;
    $[6] = t5;
    $[7] = timezone_preference;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  return t6;
};
export const useUpdateTimezonePreference = () => {
  const $ = _c(2);
  const [, setTimezonePreference] = useLocalStorage(storage_keys.timezone, null);
  let t0;
  if ($[0] !== setTimezonePreference) {
    t0 = async timezone => {
      setTimezonePreference(timezone);
    };
    $[0] = setTimezonePreference;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
};
export const useUpdateFirstDayOfWeekPreference = () => {
  const $ = _c(2);
  const [, setFirstDayOfWeekPreference] = useLocalStorage(storage_keys.first_day_of_week, null);
  let t0;
  if ($[0] !== setFirstDayOfWeekPreference) {
    t0 = async first_day_of_week => {
      setFirstDayOfWeekPreference(first_day_of_week);
    };
    $[0] = setFirstDayOfWeekPreference;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
};